const DateSvg = () => {
  return (
    <svg
      className="oa-date-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_9278_170)">
        <path
          d="M10.2 1.2H9V0.6C9 0.44087 8.93679 0.288258 8.82426 0.175736C8.71174 0.0632141 8.55913 0 8.4 0C8.24087 0 8.08826 0.0632141 7.97574 0.175736C7.86321 0.288258 7.8 0.44087 7.8 0.6V1.2H4.2V0.6C4.2 0.44087 4.13679 0.288258 4.02426 0.175736C3.91174 0.0632141 3.75913 0 3.6 0C3.44087 0 3.28826 0.0632141 3.17574 0.175736C3.06321 0.288258 3 0.44087 3 0.6V1.2H1.8C1.32261 1.2 0.864773 1.38964 0.527208 1.72721C0.189642 2.06477 0 2.52261 0 3V10.2C0 10.6774 0.189642 11.1352 0.527208 11.4728C0.864773 11.8104 1.32261 12 1.8 12H10.2C10.6774 12 11.1352 11.8104 11.4728 11.4728C11.8104 11.1352 12 10.6774 12 10.2V3C12 2.52261 11.8104 2.06477 11.4728 1.72721C11.1352 1.38964 10.6774 1.2 10.2 1.2ZM10.8 10.2C10.8 10.3591 10.7368 10.5117 10.6243 10.6243C10.5117 10.7368 10.3591 10.8 10.2 10.8H1.8C1.64087 10.8 1.48826 10.7368 1.37574 10.6243C1.26321 10.5117 1.2 10.3591 1.2 10.2V6H10.8V10.2ZM10.8 4.8H1.2V3C1.2 2.84087 1.26321 2.68826 1.37574 2.57574C1.48826 2.46321 1.64087 2.4 1.8 2.4H3V3C3 3.15913 3.06321 3.31174 3.17574 3.42426C3.28826 3.53679 3.44087 3.6 3.6 3.6C3.75913 3.6 3.91174 3.53679 4.02426 3.42426C4.13679 3.31174 4.2 3.15913 4.2 3V2.4H7.8V3C7.8 3.15913 7.86321 3.31174 7.97574 3.42426C8.08826 3.53679 8.24087 3.6 8.4 3.6C8.55913 3.6 8.71174 3.53679 8.82426 3.42426C8.93679 3.31174 9 3.15913 9 3V2.4H10.2C10.3591 2.4 10.5117 2.46321 10.6243 2.57574C10.7368 2.68826 10.8 2.84087 10.8 3V4.8Z"
          fill="#D5D5D5"
        />
      </g>
      <defs>
        <clipPath id="clip0_9278_170">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DateSvg;
